var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"layout"},[_c('LayoutHeader',{attrs:{"has-bg-color":true}}),_c('Back'),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }